define('uikit/collections/steps',['require','exports','module','underscore','marionette','../channel','../mixins/component.mixin','templates'],function(require, exports, module){
  var _ = require('underscore');
  var Mn = require('marionette');
  var channel = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates = require('templates');

  var Step = Mn.ItemView.extend(ComponentMixin).extend({

    tagName: 'li',

    attributes: {
      role: 'none presentation'
    },

    className: 'step',

    template: Templates.App['step'],

    options: {
      active: false,
      completed: false,
      description: '',
      disabled: false,
      icon: '',
      link: false,
      text: '',
      title: ''
    },

    forceUpdate: {
      active: true,
      completed: true,
      description: true,
      disabled: true,
      icon: true,
      link: true,
      text: true,
      title: true
    },

    bindings: {
      active: 'active',
      completed: 'completed',
      disabled: 'disabled',
      title: 'title',
      text: 'text',
      description: 'description',
      icon: 'icon',
      link: 'link'
    },

    updateAttributes: function() {
      this
        .addClass('active', this.getBoolOption('active'))
        .addClass('completed', this.getBoolOption('completed'))
        .addClass('disabled', this.getBoolOption('disabled'))
        .addClass('link', this.getBoolOption('link'))
    }

  });

  var Steps = Mn.CollectionView.extend(ComponentMixin).extend({

    tagName: 'ol',

    className: 'ui steps',

    childView: Step,

    options: {
      autoSize: true,
      fluid: false,
      ordered: false,
      size: '', // small or large
      tabletResponsive: false, // vertically stacks when tablet size
      vertical: false,
      attached: false
    },

    forceUpdate: {
      autoSize: true,
      fluid: true,
      ordered: true,
      vertical: true
    },

    activateAtIndex: function(nextStep) {
      var numOfSteps = this.children.length;

      if (nextStep < 0 || nextStep > (numOfSteps - 1)) {
        throw new Error(nextStep + ' is an invalid step index.');
      }

      for (var s = 0, len = numOfSteps; s < len; s++) {
        var step = this.getStep(s);

        if (s < nextStep) {
          step.completed = true;

          step.active = false;
          step.disabled = false;
        } else if (s == nextStep) {
          step.active = true;

          step.completed = false;
          step.disabled = false;
        } else if (s > nextStep) {
          step.disabled = true;

          step.active = false;
          step.completed = false;
        }
      }

      if (nextStep == (numOfSteps - 1)) {
        this.getStep(nextStep).active = false;
        this.getStep(nextStep).completed = true;
      }
    },

    getStep: function(index) {
      return this.children.findByIndex(index);
    },

    getSizeClass: function() {
      var len = this.children.length || (this.collection ? this.collection.length : 0);
      return ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight'][len] || '';
    },

    updateAttributes: function() {
      var attached = this.getOption('attached');

      this
        .addClass(this.getSizeClass(), this.getBoolOption('autoSize'))
        .addClass('fluid', this.getBoolOption('fluid'))
        .addClass('ordered', this.getBoolOption('ordered'))
        .addClass(this.getOption('size'), this.getBoolOption('size'))
        .addClass('tablet stackable', this.getBoolOption('tabletResponsive'))
        .addClass('vertical', this.getBoolOption('vertical'))
        .addClass((_.isString(attached) ? attached + ' ' : '') + 'attached', this.getBoolOption('attached'));
    }

  });

  channel.reply('steps', function() {
    return Steps;
  });

  module.exports = Steps;

});

